import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=61496e56&"
import script from "./Chart2.vue?vue&type=script&lang=ts&"
export * from "./Chart2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports